import { Stack } from '@mui/material'
import React from 'react'
import GSplatViewerHeader from './GSplatViewerHeader'
import GSplatViewer from './GSplatViewer'

type Props = {}

const GSplatViewerPage = (props: Props) => {
  return (
    <Stack sx={{ width: '100%', height: '100%' }}>
        <GSplatViewerHeader />
        <GSplatViewer sourceType='example' />
    </Stack>
  )
}

export default GSplatViewerPage